import { useEffect } from "react";

/**
 * Set document.title + description for SPA users. Bots get server-injected
 * meta via setupProxy.js — this hook only helps real visitors and social
 * preview in-page (Twitter Cards for authenticated users, etc.).
 */
export function useDocumentMeta({ title, description, image }) {
  useEffect(() => {
    if (title) document.title = `${title} · BUFL`;
    else document.title = "BUFL — Burkina United Fight League";

    const set = (selector, attr, value) => {
      if (!value) return;
      let tag = document.head.querySelector(selector);
      if (!tag) {
        tag = document.createElement("meta");
        // Parse selector like `meta[name="description"]` or `meta[property="og:image"]`
        const m = selector.match(/\[([^=]+)="([^"]+)"\]/);
        if (m) tag.setAttribute(m[1], m[2]);
        document.head.appendChild(tag);
      }
      tag.setAttribute(attr, value);
    };

    set('meta[name="description"]', "content", description);
    set('meta[property="og:title"]', "content", title);
    set('meta[property="og:description"]', "content", description);
    if (image) set('meta[property="og:image"]', "content", image);
  }, [title, description, image]);
}
